import {
  Box,
  Card,
  CardMedia,
  CircularProgress,
  Grid,
  Typography,
  Paper,
  Button,
} from "@mui/material";
import { utils } from "ethers";
import {
  getDoc,
  updateDoc,
  doc,
  collection,
  getDocs,
} from "firebase/firestore";
import { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useWeb3Context } from "../context/UseWeb3Context";
import drop from "../assets/images/drop.jpeg";
import dropFrontImg from "../assets/images/dropFront3.png";
import drop_order from "../assets/images/drop_order.png";
import mockup_black from "../assets/images/Mockup_black.jpg";
import dotrLogo from "../assets/images/DOTR-logo.png";
import sizeChart from "../assets/images/size_chart.jpeg";
import Rectangle24 from "../assets/images/Rectangle_24.png";
import maxresdefault from "../assets/images/maxresdefault.png";
import { useAuthContext } from "../context/AuthContextProvider";
// import { UseUserDocContext } from "../context/UserDocProvider";
import { ContentContainer } from "../layout/ContentContainer";
import { getUser } from "../api/users";
import IncreDecre from "./component/IncreDecre";
import Subscribe from "./component/Subscribe";
import { useSnackbar } from "notistack";
import { TitleText } from "../components/common/TitleText";
import { Info as InfoIcon } from "@mui/icons-material";
import DialogueBox from "./component/DialogueBox";
import CarouselCard from "./component/CarouselCard";

import { Dialog, DialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";

import Carousel from "react-material-ui-carousel";
import { firestore } from "../firebase";
import { sendMintMail } from "../api/mint";

export const Loading = () => {
  return (
    <>
      <Box sx={{ height: "100%", width: "100%", display: "flex" }}>
        <CircularProgress />
      </Box>
    </>
  );
};

const Drop = ({ title, total, available, NFTPrice, TshirtPrice }) => {
  const [open, setOpen] = useState(false);
  // const handleClose = (value) => {
  //   setOpen(false);
  //   setSelectedValue(value);
  // };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { account, library } = useWeb3Context();
  const { enqueueSnackbar } = useSnackbar();
  const productSize = useRef();

  const [nftData, setNftData] = useState({
    totalSupply: "",
    maxSupply: "",
    tokenPrice: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState([]);
  const { authToken, bigBeyondContract } = useAuthContext();
  const contract = useMemo(
    () => bigBeyondContract(library, account),
    [bigBeyondContract, library, account]
  );

  // const { docData } = UseUserDocContext();
  const [docData, setDocData] = useState();
  useEffect(() => {
    const getDocData = async () => {
      const docToProcess = await doc(firestore, "users", account);
      // console.log("docToProcess :", docToProcess);

      setDocData(docToProcess);
    };
    if (!(account === undefined)) {
      getDocData();
    }
  }, [account]);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      // console.log({ contract });
      const tsd = await contract.totalSupply();
      const msd = await contract.maxSupply();
      const tp = await contract.cost();

      setNftData((prev) => ({
        ...prev,
        totalSupply: tsd.toNumber(),
        maxSupply: msd.toNumber(),
        tokenPrice: utils.formatEther(tp.mul(1)),
      }));

      setIsLoading(false);
    };

    if (contract) {
      getData();
    }
  }, [contract]);

  useEffect(() => {
    if (account) {
      getUser(account).then((res) => {
        setCurrentUser(res);
      });
    }
  }, [account]);

  const mintProduct = async (nTokens) => {
    const data1 = await getDoc(docData);
    const whitelistDatas = await getDocs(collection(firestore, "whitelists"));

    const whitelistData = [];
    whitelistDatas.forEach((e) => {
      whitelistData.push(e.data().whitelist);
    });

    const areAllAccountsAllowed = whitelistData.some((e) => e === "*");
    if (!areAllAccountsAllowed) {
      const isCurrentAccountAllowed = whitelistData.some(
        (e) => e === account.toString()
      );
      if (!isCurrentAccountAllowed) {
        enqueueSnackbar("You are not allowed to mint at this time.", {
          variant: "error",
          autoHideDuration: 1500,
        });
        return;
      }
    }

    let mintData;
    if (data1.exists()) {
      if (data1.data().mintData) {
        mintData = data1.data().mintData;
      } else {
        mintData = [];
      }
    }

    setIsLoading(true);
    if (nTokens === 0) {
      alert("Mint quantity must be greater than 0");
      setIsLoading(false);
      return;
    }

    const tokenPrice = await contract.cost();
    const resData = await contract.mint(nTokens, {
      value: tokenPrice.mul(nTokens),
    });

    setIsLoading(false);

    const addMintData = () => {
      // console.log(`mint data got in addmintData fun ${mintData}`);
      mintData.push({
        hashCode: resData.hash,
        mintDate: new Date().toLocaleString(),
        price: parseFloat(nftData.tokenPrice),
        quantity: nTokens,
      });
      return mintData;
    };

    await updateDoc(docData, {
      mintData: addMintData(),
    })
      .then(async (res) => {
        await sendMintMail(
          parseFloat(nftData.tokenPrice),
          nTokens,
          currentUser.email
        );
        enqueueSnackbar("Minted successfully...!!!", {
          variant: "success",
          autoHideDuration: 1500,
        });
      })
      .catch((err) => {
        // console.log(err.message);
      });
  };

  const mintForMe = async (value) => {
    // alert(value);
    try {
      navigate(`/checkout`, {
        state: {
          quantity: value,
          mintForMe: true,
          size: "",
        },
      });
    } catch (err) {
      console.log(err);
    }

    // try {
    //   const res = await contract.mintForAddress(
    //     value,
    //     "0xf3ed561463383b1436401F074447Ef1CcC058C01"
    //   );
    //   alert("success");
    //   console.log(res);
    // } catch (err) {
    //   console.log(err);
    // }
  };

  const navigate = useNavigate();

  const aboutAuthorStyles = {
    textAlign: { md: "left", xs: "center" },
    width: { md: "100%", xs: "80%" },
  };

  const authorDescriptionStyles = {
    ...aboutAuthorStyles,
    fontSize: "12px",
  };

  return (
    <ContentContainer>
      <Grid
        container
        sx={{ marginTop: { md: "80px", xs: "40px" }, mb: "50px" }}
        column={12}
      >
        <Grid
          item
          xs={12}
          align="center"
          sx={{ mt: { md: "20px", xs: "5px" } }}
        >
          <Grid item md={6.42} xs={12} sx={{ backgroundColor: "white" }}>
            <Box display="flex" flexDirection="row" position="relative">
              <Grid item md={6.19} xs={6.19}>
                <CardMedia
                  component="img"
                  image={maxresdefault}
                  sx={{
                    width: "101%",
                    height: { md: "513px", xs: "240px" },
                    objectFit: "fill",
                    boxSizing: "border-box",
                  }}
                  alt="image"
                />
              </Grid>
              <Grid item md={5.81} xs={5.81}>
                <CardMedia
                  component="img"
                  image={dropFrontImg}
                  sx={{
                    width: "100%",
                    height: { md: "513px", xs: "240px" },
                    boxSizing: "border-box",
                    objectFit: "fill",
                  }}
                  alt="image"
                />
              </Grid>
            </Box>
            <Box position="absolute">
              <CardMedia
                component="img"
                image={dotrLogo}
                alt="image"
                sx={{
                  width: { md: "118px", xs: "60px" },
                  height: { md: "118px", xs: "60px" },
                  borderRadius: "none !important",
                  marginTop: { md: "-140px", xs: "-70px" },
                  marginLeft: { md: "20px", xs: "10px" },
                }}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12} align="center">
          <Grid item xs={12} md={6.42}>
            <Typography
              fontSize="10px"
              sx={{ marginLeft: { md: "63%", xs: "25%", marginBottom: "0px" } }}
            >
              Ava with Ukraine’s ambassador to Singapore Kateryna Zelenko
            </Typography>
            <Box sx={{ boxShadow: 2, padding: "10px 0px 20px 0px" }}>
              <TitleText variant="h4">{title}</TitleText>
              <Typography
                width="80%"
                fontSize="12px"
                lineHeight="14.4px"
                mt="5px"
              >
                Ava has illustrated a DOTR x Ukraine NFT called Spray Paint
                Ukraine. It’s a young Ukrainian girl defiantly painting a new
                future because self-belief is the best middle finger to
                oppression. Why a young girl? Because half the world are women,
                and the other half, sons.
              </Typography>

              <Typography
                sx={{
                  textAlign: "center",
                  marginTop: "10px",
                }}
                width="70%"
                fontSize="12px"
                lineHeight="14.4px"
              >
                There is a limited drop of 1,000 wearable NFTs with a free
                T-shirt. Or you can just buy the t-shirts. All proceeds (after
                costs are deducted) will be donated, not pledged, to the
                Ukrainian Embassy in Singapore. So support Ukraine! Wear this
                NFT.
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  marginTop: "10px",
                }}
                width="70%"
                fontSize="12px"
                lineHeight="14.4px"
              >
                This wouldn’t be possible without our local partner Big Beyond.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          mt="20px"
          marginTop="40px"
          sx={{ display: { md: "flex", xs: "" }, justifyContent: "center" }}
        >
          <Grid
            item
            md={6.42}
            xs={12}
            display="flex"
            sx={{ flexDirection: { md: "row", xs: "column" } }}
          >
            <Grid
              md={5.8}
              xs={12}
              align="center"
              sx={{ boxShadow: 2, marginRight: { md: "25px" } }}
            >
              <Grid item md={12} xs={12} backgroundColor="black" align="center">
                <CardMedia
                  component="img"
                  image={drop}
                  alt="image"
                  sx={{
                    objectFit: "fill",
                    height: "250px",
                    width: "250px",
                  }}
                />
              </Grid>
              <Box width="100%">
                <Typography fontSize="16px" mt="12px">
                  #dotrvivolibreukraine
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "15px",
                  }}
                >
                  <TitleText
                    fontWeight="bold"
                    sx={{ fontSize: { md: "22px", xs: "18px" } }}
                  >
                    Spray Paint Ukraine
                  </TitleText>
                  <Typography
                    sx={{
                      marginLeft: "5px",
                      fontSize: { md: "22px", xs: "18px" },
                    }}
                  >
                    | NFT
                  </Typography>
                </Box>

                <Box sx={{ width: "80%" }}>
                  <Typography fontSize="12px">
                    A young Ukrainian girl defiantly painting a new future
                    because self-belief is the best middle finger to oppression.
                  </Typography>
                </Box>
                <Typography fontSize="12px" fontWeight="900">
                  Purchase includes complimentary t-shirt.
                </Typography>

                <Typography
                  fontSize="16px"
                  mt="10px"
                  sx={{ fontWeight: "400", marginLeft: "10px" }}
                >
                  {nftData.totalSupply} / {nftData.maxSupply} minted
                </Typography>

                <Box display="flex" flexDirection="row" justifyContent="center">
                  <Box height="47px" width="47px">
                    <CardMedia
                      component="img"
                      image="https://avatars.githubusercontent.com/u/6250754?s=200&v=4"
                      alt="image"
                    ></CardMedia>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "24px",
                      mt: "4px",
                    }}
                  >
                    {nftData.tokenPrice}
                  </Typography>
                </Box>
                <Box sx={{ marginLeft: "10px", mb: "26px", mt: "10px" }}>
                  <IncreDecre
                    disabled={
                      !authToken || nftData.maxSupply === nftData.totalSupply
                    }
                    title={"MINT NOW"}
                    titleMintForMe={"Mint For Me"}
                    onBuy={(d) => {
                      if (currentUser?.email) {
                        mintProduct(d);
                      } else {
                        enqueueSnackbar(
                          "Please update your email in Edit Profile section of Profile page to recieve minting info ",
                          {
                            variant: "error",
                            autoHideDuration: 4000,
                          }
                        );
                      }
                    }}
                    onMintForMe={(d) => {
                      if (currentUser?.email) {
                        mintForMe(d);
                      } else {
                        enqueueSnackbar(
                          "Please update your email in Edit Profile section of Profile page to recieve minting info ",
                          {
                            variant: "error",
                            autoHideDuration: 4000,
                          }
                        );
                      }
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid
              md={5.8}
              xs={12}
              align="center"
              sx={{ mt: { md: "0px", xs: "40px" }, boxShadow: 2 }}
            >
              <Grid item md={12} xs={12} backgroundColor="black">
                <Box>
                  <Carousel sx={{ height: "250px" }}>
                    {[drop_order, mockup_black].map((item, i) => (
                      <CarouselCard key={i} image={item} />
                    ))}
                  </Carousel>
                </Box>
              </Grid>
              <Box width="100%">
                <Typography fontSize="16px" mt="12px">
                  #dotrvivolibreukraine
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "15px",
                  }}
                >
                  <TitleText
                    fontWeight="bold"
                    sx={{ fontSize: { md: "22px", xs: "18px" } }}
                  >
                    Spray Paint Ukraine
                  </TitleText>
                  <Typography
                    sx={{ fontSize: { md: "22px", xs: "18px" } }}
                    marginLeft="5px"
                  >
                    | Physical T-shirt
                  </Typography>
                </Box>
                <Box sx={{ width: "80%" }}>
                  <Typography fontSize="12px">
                    A young Ukrainian girl defiantly painting a new future
                    because self-belief is the best middle finger to oppression.
                  </Typography>
                </Box>
                <Typography fontSize="12px" fontWeight="900">
                  Price includes worldwide shipping.
                </Typography>
                <Typography
                  fontSize="16px"
                  mt="10px"
                  sx={{ fontWeight: "400" }}
                >
                  Unlimited Quantity
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      marginLeft: "10px",
                      marginTop: "12px",
                      fontSize: "24px",
                    }}
                  >
                    USD{TshirtPrice}
                  </Typography>
                  <select
                    ref={productSize}
                    style={{
                      width: "100px",
                      height: "30px",
                      marginTop: "15px",
                      marginLeft: "15px",
                      marginRight: "5px",
                    }}
                  >
                    <option value="" selected>
                      Sizes
                    </option>
                    <option value="XS-White">XS - White</option>
                    <option value="S-White">S - White</option>
                    <option value="M-White">M - White</option>
                    <option value="L-White">L - White</option>
                    <option value="XL-White">XL - White</option>

                    <option value="XS-Black">XS - Black</option>
                    <option value="S-Black">S - Black</option>
                    <option value="M-Black">M - Black</option>
                    <option value="L-Black">L - Black</option>
                    <option value="XL-Black">XL - Black</option>
                  </select>
                  <Box display="flex" alignItems="flex-end">
                    <InfoIcon
                      sx={{
                        marginBottom: "5px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => setOpen(true)}
                    />
                  </Box>
                  <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                  >
                    <DialogueBox
                      id="customized-dialog-title"
                      onClose={handleClose}
                      // sx={{ height: "20px" }}
                    ></DialogueBox>
                    <DialogContent sx={{ overflow: "hidden" }}>
                      <CardMedia
                        component="img"
                        image={sizeChart}
                        alt="image"
                        sx={{
                          objectFit: "contain",
                        }}
                      ></CardMedia>
                    </DialogContent>
                  </BootstrapDialog>
                </Box>

                <Box mt="10px">
                  <IncreDecre
                    disabled={!authToken}
                    title={"BUY NOW"}
                    onBuy={(d) => {
                      if (currentUser?.address?.street && currentUser?.email) {
                        if (productSize.current.value) {
                          navigate(`/checkout`, {
                            state: {
                              quantity: d,
                              mintForMe: false,
                              size: productSize.current.value,
                            },
                          });
                        } else {
                          alert("Select Product Size");
                        }
                      } else {
                        enqueueSnackbar(
                          "Please update your address & email id in Edit Profile section of Profile page",
                          {
                            variant: "error",
                            autoHideDuration: 4000,
                          }
                        );
                      }
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            display: { md: "flex", xs: "flex" },
            marginTop: "38px",
            justifyContent: "center",
          }}
          container
          marginTop="40px"
          marginBottom="20px"
        >
          <Grid
            item
            md={6.42}
            xs={12}
            display="flex"
            sx={{
              flexDirection: { md: "row", xs: "column" },
              boxShadow: 2,
              backgroundColor: "#F5F5F5",
            }}
            mt="10px"
          >
            <Grid item md={5.4} xs={12}>
              <CardMedia
                component="img"
                image={Rectangle24}
                alt="image"
                sx={{
                  objectFit: "fill",
                  height: { md: "512px" },
                  width: { md: "346px" },
                }}
              ></CardMedia>
            </Grid>
            <Grid
              item
              md={8}
              xs={12}
              display="flex"
              flexDirection="column"
              sx={{
                justifyContent: { md: "left", xs: "center" },
                padding: { md: "20px 0px", xs: "20px 10px" },
                paddingLeft: { md: "25px" },
                marginTop: { md: "160px" },
                marginLeft: { md: "10px" },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  marginLeft: { md: "0.7rem" },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <TitleText
                  variant="h4"
                  fontWeight="bold"
                  fontSize="36px"
                  sx={aboutAuthorStyles}
                >
                  about the artist
                </TitleText>

                <Typography
                  mt="10px"
                  lineHeight="14px"
                  sx={authorDescriptionStyles}
                >
                  Hi I’m Ava Soh.
                </Typography>
                <Typography
                  lineHeight="14px"
                  marginTop="14px"
                  marginRight="1rem"
                  sx={authorDescriptionStyles}
                >
                  When I was 14, I created my brand Daughters Of The Revolution
                  (DOTR) to empower the next generation of 21st century heroines
                  through self love. We empower ourselves when we learn to love
                  ourselves first.
                </Typography>
                <Typography
                  lineHeight="14px"
                  marginTop="14px"
                  marginRight="1rem"
                  sx={authorDescriptionStyles}
                >
                  DOTR x Ukraine wearable NFTs - As you well know, there’s a war
                  going on. And once again, innocent women and children are on
                  the receiving end, with emotional battle scars that will last
                  generations.
                </Typography>
                <Typography
                  lineHeight="14px"
                  marginTop="14px"
                  marginRight="1rem"
                  sx={authorDescriptionStyles}
                >
                  I believe there’s a humane generation who want to help and
                  NFTs can amplify that. And maybe that’s how we can demonstrate
                  the true power of decentralised good.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Subscribe />
    </ContentContainer>
  );
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

Drop.defaultProps = {
  title: "Daughters Of  The Revolution (DOTR)",
  total: 10000,
  available: 10000,
  NFTPrice: 406.39,
  TshirtPrice: 100,
};

export default Drop;
